import Footer from "../components/footer";
import { Navigation } from "../components/navigation";

export function HomeLayout({children}) {
    return (
        <>
            <Navigation />
            {children}
            <Footer />
        </>
    );
}